import "./Cards.css";
import Test from "./test";
import Cards from "./Cards";
export default function Projects() {
  return (
    <>
      <h1 style={{ textAlign: "center" }}>Past Projects</h1>
      <Test />
    </>
  );
}
